import React, { useEffect } from "react"

import { useNavigate } from "react-router-dom"

const Index = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect to login page
    navigate("/login")
  }, [navigate])

  return (
    <div className="flex items-center justify-center h-[calc(100vh-200px)]">
      <p className="text-palette-jungleGreen500">Redirecting to login...</p>
    </div>
  )
}

export default Index
